export const SET_ACTIVE_PAGE_NAME = "GLOBAL_STATE:SET_ACTIVE_PAGE_NAME";
